import { connect } from 'react-redux';
import { useState, useEffect, useRef } from 'react';
import { SET_NEW_PROJECT_DIALOGUE_SHOWING, SiteboardApiValidator, ADD_PROJECT } from '../actions/types';
import { setPath, siteboardAction } from '../actions/defaultActions';
import { isArray } from '../Util';

// icon imports
import EditIcon from '../icons/editIcon';
import ExpandDownIcon from '../icons/expandDownIcon';
import AddIcon from '../icons/addIcon';

// test cases
const testScrollPanes = false; // add a bunch of copies to scrollable area to see what they look like when full of data
const testEmptyState = false; // show the components as if there were no data to populate it
const testUserCanCreateProject = false; // show the component as if the user was an account manager
const testUserCannotCreateProjects = false; // show the component as if the user was not an account manager

const ProjectList = ({ _projects, _subscriptions, _userId, setPath, siteboardAction, projectId }) => {

  // TODO: can probably read state.path to get the active project id instead of taking it as a parameter
  const dropdownRef = useRef(null);
  const [projectsListShowing, setProjectsListShowing] = useState(false);
  useEffect(() => { setProjectsListShowing(false); }, [projectId]);

  // Close dropdown list if mouse is pressed outside of it
  // TODO: do this for touch devices too
  useEffect(() => {
    const onMouseDown = (event) => {
     try {
       let element = event.target;
       do {
         if (element === dropdownRef.current) return;
         element = element.parentNode;
       } while(element.tagName !== 'body' && element.tagName !== 'BODY');
       setProjectsListShowing(false);
     } catch(error) {}
    };

    window.addEventListener('mousedown', onMouseDown);
    return () => { // remove listener when component unloads
      window.removeEventListener('mousedown', onMouseDown);
    };
  }, []);

  const selectedProject = projectId in _projects ? _projects[projectId] : {};
  const otherProjects = [];
  for(const key in _projects) {
    if(key !== projectId && typeof _projects[key].name === 'string' && _projects[key].name.length > 0) {
      for(let i = 0; i < (testScrollPanes ? 20 : 1) && !testEmptyState; i++) {
        otherProjects.push(_projects[key]);
      }
    }
  }
  otherProjects.sort((one, two) => {
    try {
      return one.name.toLowerCase().localeCompare(two.name.toLowerCase());
    } catch(error) {}
    return one.createdTimestamp - two.createdTimestamp;
  });

  let userCanCreateProjects = false;
  for(const subscriptionId in _subscriptions) {
    if(SiteboardApiValidator[ADD_PROJECT].isUserIdAuthorized(_userId, _subscriptions[subscriptionId], null)) {
      userCanCreateProjects = true;
      break;
    }
  }
  if(testUserCanCreateProject) userCanCreateProjects = true;
  if(testUserCannotCreateProjects) userCanCreateProjects = false;

  return (
    <div 
      ref={dropdownRef}
      className={'w-full flex flex-col text-white relative '}
    >
      <button
        className={`flex justify-between min-h-[32px] ${projectsListShowing ? 'bg-neutral-700' : 'hover:bg-neutral-700 '} border-t border-b border-[#f9a928cc] justify-between items-center py-[9px] px-[14px] relative`}
        onClick={() => { setProjectsListShowing(!projectsListShowing); }}
      >
        <p className='grow text-left font-bold leading-[1.2em]'>{selectedProject.name}</p>
        <div className='px-2 py-1'>
          <div className={projectsListShowing ? 'scale-[-1]' : ''}>
            <ExpandDownIcon />
          </div>
        </div>
      </button>
      {projectsListShowing && 
        <div className='absolute z-[1] top-full flex flex-col bg-[#333] text-white w-full py-1 animate-up-fade max-h-[65vh] overflow-y-auto'>
          <div className='flex flex-col basis-0'>
            {otherProjects.length === 0 && 
              <div className='p-4'>No other projects</div>
            }
            {otherProjects.length > 0 &&
              otherProjects.map((project, index) => (
                <button 
                  key={index}
                  className='text-left hover:bg-[#555] px-8 py-4 leading-[1.2em]'
                  onClick={() => { 
                    setPath('projectId#' + project.id + '#schedule'); 
                  }}
                >
                  {project.name}
                </button>
              ))
            }
            {userCanCreateProjects && 
              <>
                <div className='w-full h-[1px] bg-[#555] my-1 px-4'></div>
                <button 
                  className='flex items-center items-start gap-x-1.5 hover:bg-[#555] px-8 py-4 leading-[1.2em]'
                  onClick={() => {
                    setProjectsListShowing(false);
                    siteboardAction(SET_NEW_PROJECT_DIALOGUE_SHOWING, { isOpen: true });
                  }}
                >
                  <AddIcon color='#fff' /> Create Project
                </button>
              </>
            }
          </div>
        </div>
      }
    </div>
  );
}

const mapStateToProps = state => { return { // define redux state that will be passed in as props
  _userId: state.localPersistent.userId,
  _projects: state.serverSynced.projects,
  _subscriptions: state.serverSynced.subscriptions,
}};
export default connect(mapStateToProps, {setPath, siteboardAction})(ProjectList);
